import numeral from 'numeral'
import type { CountryCode, NumberFormat } from 'libphonenumber-js/max'
import { parsePhoneNumber } from 'libphonenumber-js/max'
import { isValidPhoneNumber } from '../is-valid'
import { toDate } from '../to-date'
import type { DateType } from '../to-date/DateType'

export const formatConstants = {
  isoDate: 'YYYY-MM-DDTHH:mm:ss.sssZ',
  date: 'MMM DD, YYYY',
  dateTime: 'MMM DD, YYYY h:mm A',
  reallyShortDate: 'MMM DD',
  shortDate: 'YYYY-MM-DD',
  number: '0,0',
  number2: '0,0.00',
  number3: '0,0.000',
  number4: '0,0.0000',
  numberA: '0,0a',
  money: '$0,0.00',
  money4: '$0,0.0000',
  percent: '0.00%',
  percent_0: '0%',
  bytes: '0.00 b',
}
export const formatNumber = (number?: number, format?: string) => {
  if (!number) number = 0
  if (format) {
    return numeral(number).format(format)
  }
  return numeral(number).format(formatConstants.number)
}
export const formatNumber2 = (num?: number) => {
  return formatNumber(num, formatConstants.number2)
}
export const formatNumber4 = (num?: number) => {
  return formatNumber(num, formatConstants.number4)
}
export const formatNumberA = (num?: number) => {
  return formatNumber(num, formatConstants.numberA)
}
export const formatMoney = (num?: number) => {
  return formatNumber(num, formatConstants.money)
}
export const formatMoney4 = (num?: number) => {
  return formatNumber(num, formatConstants.money4)
}
export const formatPercent = (num?: number) => {
  return formatNumber(num, formatConstants.percent)
}
export const formatPercent0 = (num?: number) => {
  return formatNumber(num, formatConstants.percent_0)
}
export const formatQuantity = (quantity?: number, decimalPrecision = 0) => {
  const format = decimalPrecision > 0 ? '0,0.' + '0'.repeat(decimalPrecision) : '0,0'
  return formatNumber(quantity, format)
}

export const formatDate = (date?: DateType, format?: string, timeZone?: string) => {
  format = format || formatConstants.date
  return toDate(date, timeZone).format(format)
}
export const formatReallyShortDate = (date?: DateType) => {
  return formatDate(date, formatConstants.reallyShortDate)
}

export const formatShortDate = (date?: DateType) => {
  return formatDate(date, formatConstants.shortDate)
}

export const formatDateTime = (dateTime?: DateType) => {
  return formatDate(dateTime, formatConstants.dateTime)
}

/**
 * Formats the phone number into a INTERNATIONAL FORMAT (e.g +1 213-456-7890 ext. 123)
 * If the value cannot be formatted we just return as null
 * @param phoneNumber
 * @param countryCode
 */
export const formatPhoneNumber = (phoneNumber: string, countryCode: CountryCode = 'US'): string => {
  try {
    const result = null

    if (isValidPhoneNumber(phoneNumber, countryCode)) {
      const parsedPhoneNumber = parsePhoneNumber(phoneNumber, countryCode)

      if (parsedPhoneNumber) {
        const numberFormat: NumberFormat = 'INTERNATIONAL' //this will enforce as the international phone number formatting
        return parsedPhoneNumber.format(numberFormat)
      }
    }

    return result
  } catch (e) {
    return null
  }
}
